module.exports = __webpack_public_path__ + "static/media/SourceSansPro-It.9872c585.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-It.eot
// module id = 88
// module chunks = 3